import type { KeyboardEvent } from "react";

/**
 * Keyboard handler for elements with role="button": activates on Enter or Space
 * (WCAG button semantics for non-native button elements).
 */
export function activateOnKey(handler: () => void) {
  return (event: KeyboardEvent): void => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };
}
